import { Leaf } from "lucide-react";

const ITEMS = [
    "Heckenschnitt",
    "Pflasterreinigung",
    "Rasenpflege & Reparatur",
    "Laubentfernung",
    "Celle",
    "Hambühren",
    "Winsen (Aller)",
    "Wietze",
    "Eschede",
    "Lachendorf",
    "Bergen",
    "Reinigung — Pflege — Werterhalt",
];

export const Marquee = () => (
    <div className="relative bg-forest-deep border-y border-forest-line py-5 overflow-hidden" data-testid="editorial-marquee">
        <div className="flex w-max animate-marquee">
            {[...ITEMS, ...ITEMS].map((t, i) => (
                <span key={i} className="flex items-center gap-10 pr-10 font-mono text-xs sm:text-sm uppercase tracking-[0.28em] text-white/55">
                    {t}
                    <Leaf size={12} className="text-leaf/70" />
                </span>
            ))}
        </div>
    </div>
);
